// loaders.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Log } from '@probe.gl/log';
export const log = new Log({ id: 'loaders.gl' });
